module.exports = __webpack_public_path__ + "static/media/Education - Technology.0262ebd7.svg";